import { Injectable } from '@angular/core';

// yyyy-MM-dd taken from https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/date
export type DateString = `${number}-${number}-${number}`;
// yyyy-MM-ddTHH:mm taken from https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/datetime-local#max
export type DateTimeString =
  `${number}-${number}-${number}T${number}:${number}`;

@Injectable({
  providedIn: 'root',
})
export class DateConstantsService {
  // Date format constants
  readonly MIN_DATE: DateString = '1950-01-01';
  readonly MAX_DATE: DateString = '2050-12-31';

  // DateTime format constants
  readonly MIN_DATETIME: DateTimeString = '1950-01-01T00:00';
  readonly MAX_DATETIME: DateTimeString = '2050-12-31T23:59';
}
